import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import AuthorizedLayout from '../../shared/layout/AuthorizedLayout';
import { useStyles } from './styles';
import BookingList from './booking-list';

export const Bookings = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <AuthorizedLayout title="Exercices">
      <Box className={classes.mainContainer}>
        <Box className={classes.contentContainer}>
          <Typography variant="h2">
            {t('v2.bookings.header_label_title')}
          </Typography>
          <Typography className={classes.contentTopDescription}>
            {t('v2.bookings.header_label_subtitle')}
          </Typography>
          <BookingList />
        </Box>
      </Box>
    </AuthorizedLayout>
  );
};
